"use client"

import { Address, Customer } from "@medusajs/medusa"
import AddressItem from "./components/address-item"
import AddressEmpty from "./components/address-empty"
import { useEffect, useState } from "react"
import { useDeliverySelector } from "@lib/hooks/use-delivery-select"
import { getCustomerAddresses } from "@lib/util/address-utils"

export default function AddressSelect(props: {
  customer: Customer | undefined
}) {
  const deliverySelector = useDeliverySelector()
  const [selectedNum, setSelectedNum] = useState(0)
  const [addresses, setAddresses] = useState<Address[]>(
    props.customer?.shipping_addresses || []
  )

  const handleSelectedNum = (num: number) => {
    setSelectedNum(num)
    deliverySelector.setAddress(addresses[num])
  }

  useEffect(() => {
    deliverySelector.setAddress(addresses[selectedNum])
  }, [])

  return (
    <div className="flex flex-col items-center justify-start w-full min-h-[8rem] xl:max-w-md max-w-5xl bg-[#FAFAF5] border border-[#E6E6E6] rounded-2xl p-3">
      <h1 className="w-full text-center pb-2 text-lg font-medium border-b border-[#E6E6E6]">
        Výběr dodací adresy
      </h1>
      <div className="flex flex-col w-full">
        {addresses.length == 0 && <AddressEmpty />}
        {addresses?.map((shippingAddress, index) => {
          return (
            <AddressItem
              key={index}
              address={shippingAddress}
              addressIndex={index}
              selected={index === selectedNum}
              handleSelected={() => {
                handleSelectedNum(index)
              }}
              contacts={{
                telephone: shippingAddress.phone || props.customer?.phone || "",
                email: props.customer?.email,
              }}
            />
          )
        })}
      </div>
    </div>
  )
}
